import { useTranslation } from 'react-i18next'
import {
  Grid,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  InputAdornment,
  Typography,
  FormHelperText,
  Divider,
} from '@mui/material'
import { useField, useFormikContext } from 'formik'

import InputFormikField from '@/views/components/input-formik-field/index.component'
import { FormValuesManualWallet } from '@/views/wallets/hooks/use-wallets-schema.hook'
import { BonusType, RolloverTypeEnum } from '@/enums'

import { ProviderComponent, PlayerUsernameComponent } from './'

type Props = {
  bonusType: BonusType
}

export const ManualTriggerFormComponent = ({ bonusType }: Props) => {
  const { t } = useTranslation()

  const [fieldRolloverType] = useField('rolloverType')
  const [fieldRollover] = useField('rollover')
  const [fieldBonusAmount] = useField('bonusAmount')

  const { setFieldValue } = useFormikContext<FormValuesManualWallet>()

  return (
    <>
      <Grid container spacing={1}>
        <PlayerUsernameComponent />
        <Grid item xs={12}>
          <InputFormikField
            label={t('labels.bonusAmount')}
            name="bonusAmount"
          />
        </Grid>
        <Grid item xs={12}>
          <Box marginTop="10px">
            <Divider light />
          </Box>
          <Box mt={1}>
            <FormControl margin="dense">
              <RadioGroup
                row
                name="rolloverType"
                value={fieldRolloverType.value}
                onChange={(event) =>
                  setFieldValue('rolloverType', event.target.value)
                }
              >
                <>
                  <FormControlLabel
                    value={RolloverTypeEnum.COEFFICIENT}
                    control={<Radio color="primary" />}
                    label={t('wallet.coefficient')}
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value={RolloverTypeEnum.TOTAL_AMOUNT}
                    control={<Radio color="primary" />}
                    label={t('wallet.totalRolloverAmount')}
                    labelPlacement="end"
                  />
                </>
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <InputFormikField
            label={t('labels.rolloverCoefficient')}
            name="rollover"
            InputProps={{
              endAdornment:
                fieldRolloverType.value === RolloverTypeEnum.COEFFICIENT &&
                fieldRollover.value !== '' ? (
                  <InputAdornment position="end">
                    <Typography variant="body2">{`(${fieldRollover.value}x * ${
                      fieldBonusAmount.value
                    }) = ${
                      Number(fieldRollover.value) * fieldBonusAmount.value
                    } ${t('wallet.inTotalRolloverAmount')}`}</Typography>
                  </InputAdornment>
                ) : undefined,
            }}
          />
          <FormHelperText>
            {fieldRolloverType.value === RolloverTypeEnum.COEFFICIENT
              ? t('wallet.rolloverAmountCoefficientHelper')
              : t('wallet.rolloverAmountTotalHelper')}
          </FormHelperText>
          <Box marginTop="15px" marginBottom="5px">
            <Divider light />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <InputFormikField label={t('bonusMaxWin')} name="maxWin" />
        </Grid>
        <Grid item xs={12}>
          <ProviderComponent bonusType={bonusType} />
        </Grid>
        <Grid item xs={12}>
          <InputFormikField
            label={t('labels.comment')}
            name="comment"
            minRows={2}
          />
        </Grid>
      </Grid>
    </>
  )
}
